<template>
    <h1>Privacy Policy</h1>
</template>